var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record.type && _vm.record.type === 'adv')?_c('div',[_vm._t("adv")],2):_c('personal-selection-item',{attrs:{"record":_vm.record},on:{"recordShown":_vm.emitRecordShow,"recordClicked":_vm.emitRecordClick}})}
var staticRenderFns = []

export { render, staticRenderFns }